const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/settings/management/integrations/hubspot/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireAdmin } from '@/Router';
import { HsInfoQuery, type Integration_HubspotInfo_Query } from '@/graphql/queries/Integration.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { Skeleton } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
/**
 * select the properties you wish to sync with Zngly
 */

export const Route = createFileRoute('/dash/settings/management/integrations/hubspot/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader() {
    return loadQuery<Integration_HubspotInfo_Query>(RelayEnvironment, HsInfoQuery, {}, {
      fetchPolicy: 'store-or-network'
    });
  },
  beforeLoad() {
    requireAdmin();
  },
  pendingComponent: () => <Skeleton sx={{
    width: '100%'
  }} height={200} />
});